import * as React from "react";
import {Component} from "react";
import { connect } from "react-redux";

import DeliveryStatus from "../../screens/DeliveryStatus";

import {postDeliverystatus, getDeliverystatus, statuspageSelected, deleteStatus, editDeliverystatus} from "./action";

class DeliveryStatusContainer extends Component {
  render() {
    return <DeliveryStatus 
    postDeliverystatus={this.props.postDeliverystatus}
    getDeliverystatus = {this.props.getDeliverystatus}
    deliveryStatus={this.props.deliveryStatus}
    deliveryStatusCount={this.props.deliveryStatusCount}
    statuspageSelected={this.props.statuspageSelected}
    deleteStatus={this.props.deleteStatus}
    editDeliverystatus={this.props.editDeliverystatus}
    />;
  }
}
function bindAction(dispatch) {
  return {
     postDeliverystatus: (value) => {
      dispatch(postDeliverystatus(value));
    },
    getDeliverystatus:(value)=>{
        dispatch(getDeliverystatus(value));
    },
    statuspageSelected:(value)=>{
      dispatch(statuspageSelected(value));
    },
    deleteStatus:(value)=>{
      dispatch(deleteStatus(value));
    },
    editDeliverystatus:(value)=>{
      dispatch(editDeliverystatus(value));
    },
   };
}

const mapStateToProps = (state) => {
  return {
    deliveryStatus: state.DeliveryStatusReducer.deliveryStatus,
    deliveryStatusCount:state.DeliveryStatusReducer.deliveryStatusCount
  };
};

export default connect(mapStateToProps, bindAction)(DeliveryStatusContainer);
